export const pbColors = {
  Currency: "#bd4b9b",
  FNO: "#f7943e",
  Equity: "#1c9ad6",
  MutualFund: "#f5690f",
  Commodity: "#a142f4",
};

export const pbClassNames = {
  Currency: "Currency",
  FNO: "fno",
  Equity: "equity",
  MutualFund: "mutual-fund",
  Commodity: "commodity",
};

export const progress_bar = [
  {
    name: "Equity",
    price: 0,
    percent: 0,
    ratio: 0,
    className: pbClassNames.Equity,
    color: pbColors.Equity,
  },
  {
    name: "FNO",
    price: 0,
    percent: 0,
    ratio: 0,
    className: pbClassNames.FNO,
    color: pbColors.FNO,
  },

  {
    name: "Currency",
    price: 0,
    percent: 0,
    ratio: 0,
    className: pbClassNames.Currency,
    color: pbColors.Currency,
  },
];
